<template>
    <div>
        <div v-if="progress">
            <h3 class="normal-text big-text align-center">
                {{ progress.title }}
            </h3>
            <div class="card-inner">
                <div class="course-progress" :placeholder="`${progress.progress}%`">
                    <div class="canvas-outer"></div>
                    <canvas ref="profile-course-progress" style="transform: rotate(-90deg);"></canvas>
                </div>
            </div>
            <div class="">
                <a :href="`/resources/${progress.slug}`">
                    <div class="general-button">
                        <p>
                            {{ $t('membership.view_course') }}
                        </p>
                    </div>
                </a>
            </div>
        </div>
        <div v-else>
            <p class="tw-text-gray-400">{{ $t('elearning.not_started') }}</p>
        </div>
    </div>

</template>

<script>
export default {
    name: 'CurrentlyLearning',

    props: ['profile'],

    data() {
        return {
            progress: null
        }
    },

    methods: {
        getProgress() {
            axios.get(`/api/v3/users/${this.profile.id}/progress`).then((response) => {
				const responseData = response.data.data;

				if (responseData && Object.keys(responseData).length > 0) {
					this.progress = response.data.data;
					this.drawCanvas();
				}
            });
        },

        drawCanvas() {
            this.$nextTick(function () {
                const lastCourse = this.$refs['profile-course-progress'];
                const lastCourseProgress = this.progress.progress;

                if (lastCourse) {
                    const context = lastCourse.getContext('2d');

                    const percentage = lastCourseProgress / 100;

                    lastCourse.width = 200;
                    lastCourse.height = 200;
                    lastCourse.style.width = "100px";
                    lastCourse.style.height = "100px";

                    const degrees = percentage * 360.0;
                    const radians = degrees * (Math.PI / 180);

                    const x = 50;
                    const y = 50;
                    const r = 30;
                    const s = 0;//1.5 * Math.PI;

                    context.scale(2, 2);
                    context.beginPath();
                    context.strokeStyle = '#696969';
                    context.lineWidth = 5;
                    context.arc(x, y, r, s, radians, false);
                    //context.closePath();
                    context.stroke();
                }
            })
        },
    },

    mounted() {
        this.getProgress();
    }
}
</script>

<style lang="scss" scoped>
.course-progress {
    position: relative;
    height: 110px;
    transition: transform .5s
}

.course-progress .canvas-outer {
    width: 65px;
    height: 65px;
    position: absolute;
    left: 0;
    right: 0;
    top: 19.5px;
    margin: auto;
    border-radius: 100%;
    border: 5px solid #e0e0e0;
    background: #fff;
    transition: background .5s
}

.course-progress canvas {
    transform: rotate(-90deg);
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 2px
}

.course-progress:before {
    z-index: 1;
    position: absolute;
    opacity: 0;
    content: attr(placeholder);
    color: #c7c7c7;
    left: 0;
    right: 0;
    text-align: center;
    top: 40px;
    font-size: 17px;
    transition: opacity .3s
}

.course-progress:hover {
    cursor: pointer;
    transform: scale(1.1)
}

.course-progress:hover .canvas-outer {
    background: #f9f9f9
}

.course-progress:hover:before {
    opacity: 1
}
</style>